import React from 'react';

interface SelectOption {
  value: string;
  label: string;
}

interface SelectFieldProps {
  label: string;
  value: string;
  options: SelectOption[];
  onChange: (value: string) => void;
  helpText?: string;
}

const SelectField: React.FC<SelectFieldProps> = ({ label, value, options, onChange, helpText }) => (
  <label className="block">
    <div className="mb-2 text-[11px] font-semibold uppercase tracking-[0.3em] text-amber-100/55">{label}</div>
    <select
      value={value}
      onChange={(event) => onChange(event.target.value)}
      className="w-full rounded-2xl border border-white/10 bg-[#120807] px-4 py-3 text-white focus:border-amber-400/35 focus:outline-none"
    >
      {options.map((option) => (
        <option key={option.value} value={option.value} className="bg-[#120807] text-white">
          {option.label}
        </option>
      ))}
    </select>
    {helpText && <div className="mt-2 text-sm text-white/45">{helpText}</div>}
  </label>
);

export default SelectField;

